import { FC } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { MediaCardCompilationSkeleton } from '@shared/ui/Layout/Cards/MediaCardCompilation'

interface Props {
  className?: string
  sizes: string
}

const Skeleton: FC<Props> = (props) => {
  return (
    <BlockBoundary>
      <MediaCardCompilationSkeleton {...props} />
    </BlockBoundary>
  )
}

export default Skeleton
